import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import DashboardChartMapContainer from './components/DashboardChartMapContainer';
import * as actions from './action';
import * as c from './constant';

function DashboardContainer({ totalStats, getTotalStats }) {
  const returnBillsData = () => {
    const data = _.get(totalStats, 'item.total_cash_transfer_transaction_per_status');
    return {
      label: 'Transferred',
      total: _.get(data, 'TRANSFERRED', 0),
    };
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard
            data={returnBillsData()}
            className="mb-2"
          />
        </div>
        <div className="col-8 pr-0">
          <DashboardChartMapContainer />
        </div>
      </div>
    </div>
  );
}

DashboardContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DashboardContainer);
